import * as React from 'react';

const Packages = ({ width, height }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
  >
    <path
      d='M15.9999 17.7338C15.8266 17.7338 15.6533 17.6938 15.4933 17.6005L3.71995 10.7871C3.25328 10.5071 3.07995 9.89379 3.35995 9.41379C3.63995 8.93379 4.25328 8.77379 4.73328 9.05379L15.9999 15.5738L27.1999 9.09379C27.6799 8.81379 28.2933 8.98713 28.5733 9.45379C28.8533 9.93379 28.6799 10.5471 28.2133 10.8271L16.5199 17.6005C16.3466 17.6805 16.1733 17.7338 15.9999 17.7338Z'
      fill='#333333'
    />
    <path
      d='M16 29.8131C15.4533 29.8131 15 29.3597 15 28.8131V16.7197C15 16.1731 15.4533 15.7197 16 15.7197C16.5467 15.7197 17 16.1731 17 16.7197V28.8131C17 29.3597 16.5467 29.8131 16 29.8131Z'
      fill='#333333'
    />
    <path
      d='M16.0001 30.3337C14.8268 30.3337 13.6668 30.0803 12.7468 29.5737L5.62677 25.6137C3.69343 24.547 2.18677 21.9737 2.18677 19.7603V12.227C2.18677 10.0137 3.69343 7.45366 5.62677 6.37366L12.7468 2.42699C14.5734 1.41366 17.4268 1.41366 19.2534 2.42699L26.3734 6.38699C28.3068 7.45366 29.8134 10.027 29.8134 12.2403V19.7737C29.8134 21.987 28.3068 24.547 26.3734 25.627L19.2534 29.5737C18.3334 30.0803 17.1734 30.3337 16.0001 30.3337ZM16.0001 3.66699C15.1601 3.66699 14.3334 3.84033 13.7201 4.17366L6.6001 8.13366C5.3201 8.84033 4.18677 10.7603 4.18677 12.227V19.7603C4.18677 21.227 5.3201 23.147 6.6001 23.867L13.7201 27.827C14.9334 28.507 17.0668 28.507 18.2801 27.827L25.4001 23.867C26.6801 23.147 27.8134 21.2403 27.8134 19.7603V12.227C27.8134 10.7603 26.6801 8.84033 25.4001 8.12033L18.2801 4.16033C17.6668 3.84033 16.8401 3.66699 16.0001 3.66699Z'
      fill='#333333'
    />
  </svg>
);

export default Packages;
